function getTextWidth(txt) {
  const element = document.createElement('canvas')
  const context = element.getContext('2d')
  context.font = 'normal 14px SFProText-Regular'

  return context.measureText(txt).width
}

export default getTextWidth
